import React, { useState } from 'react';
import { ZoomIn } from 'lucide-react';
import { getImageUrl } from '../../utils/imageUtils.js';

const labels = {
  ne: {
    title: 'ग्यालेरी',
    subtitle: 'यस क्षेत्रसँग सम्बन्धित तस्वीरहरू।',
  },
  en: {
    title: 'Gallery',
    subtitle: 'Images related to this sector.',
  },
};

const SectorGallery = ({ gallery, language = 'ne' }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const t = labels[language] || labels.ne;

  if (!gallery || gallery.length === 0) {
    return null;
  }

  return (
    <section className="sector-gallery">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">{t.subtitle}</p>
        </div>

        <div className="gallery__grid">
          {gallery.map((item, index) => (
            <button
              key={index}
              className="gallery-item"
              onClick={() => setSelectedImage(item)}
              type="button"
            >
              <img src={getImageUrl(item.image)} alt={item.caption} />
              <div className="gallery-item__overlay">
                <ZoomIn size={30} />
                <p>{item.caption}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)} role="presentation">
          <div className="lightbox__content" onClick={(event) => event.stopPropagation()} role="presentation">
            <button className="lightbox__close" type="button" onClick={() => setSelectedImage(null)} aria-label="Close image">
              &times;
            </button>
            <img src={getImageUrl(selectedImage.image)} alt={selectedImage.caption} />
            <p className="lightbox__caption">{selectedImage.caption}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default SectorGallery;
